import axios from 'axios';
import API_BASE_URL from '../apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

// Function to validate user
export const validateUser = async () => {
  try {
    const response = await api.get("/api/validate-user");
    if (response.data) {
      return true; // If the response contains user data, the user is valid
    }
    return false; // If no data is returned, the user is not valid
  } catch (error) {
    return false; // In case of error (e.g., invalid token or expired session)
  }
};